<template>
    <flickity :options="flickityOptions">
        <div v-for="(influencer, index) in influencers" :key="index" class="carousel-cell w-1/2 md:w-1/4 hover:invert-color md:hover:bg-warm-blue transition-normal text-grape-purple-two md:hover:text-white py-4">
            <div class="px-4 md:px-0">
                <img :src="influencer.imagePath" alt="" class="rounded-full mb-8 h-avatar-sm md:h-auto">
                <div class="md:w-3/4 mx-auto">
                    <h4 class="text-lg font-bold md:text-2xl mb-4">{{ influencer.name }}</h4>
                    <span class="w-3/5 md:w-3/4 mx-auto mb-3 h-px bg-grape-purple block separator transition-normal"></span>
                    <p class="text-xs md:text-base">{{ influencer.place }}</p>
                    <div class="mt-6">
                        <span class="mr-2">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="h-10 w-10"  x="0px" y="0px"
	                            viewBox="0 0 43 42" style="enable-background:new 0 0 43 42;" xml:space="preserve">
                                <g transform="translate(368 6244)">
                                    <g transform="translate(90 391)">
                                        <ellipse class="st0" cx="-436.9" cy="-6614" rx="21.1" ry="21"/>
                                        <path class="st1" d="M-433.6-6626.6c0.4,2.5-1.7,5.1-4,5C-438.2-6623.6-436.1-6626.3-433.6-6626.6z M-428.9-6619.1
                                            c-3.3,2.2-3.3,6.7,0.6,8.7c-0.7,1.9-1.7,3.7-3.3,5.1c-0.9,0.8-1.9,0.9-3,0.4c-1.7-0.8-3.4-0.8-5.1,0c-1.1,0.5-2.2,0.3-3-0.5
                                            c-3.1-3.2-4.7-6.9-3.8-11.3c0.5-2.8,3-4.7,5.8-4.5c0.7,0.1,1.3,0.2,1.9,0.5c1,0.5,1.9,0.4,2.9,0c1.5-0.7,3.1-0.8,4.7-0.2
                                            C-430.3-6620.5-429.5-6620-428.9-6619.1z"/>
                                    </g>
                                </g>
                            </svg>
                        </span>
                        <span class="ml-2">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="h-10 w-10" x="0px" y="0px"
                                viewBox="0 0 43 42" style="enable-background:new 0 0 43 42;" xml:space="preserve">
                                <g transform="translate(-520 -6635)">
                                    <g transform="translate(368 6244)">
                                        <g transform="translate(152 391)">
                                            <ellipse class="st0" cx="21.9" cy="21" rx="21.1" ry="21"/>
                                            <path class="st1" d="M31.6,20.3c0,0.9,0,1.9,0,2.8c0,0.7-0.5,1.3-1.2,1.4c-0.7,0.1-1.3-0.4-1.5-1c0-0.1,0-0.2,0-0.4
                                                c0-1.9,0-3.8,0-5.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C31.6,18.4,31.6,19.3,31.6,20.3 M14.9,20.2c0,0.9,0,1.9,0,2.8
                                                c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-1.9,0-3.7,0-5.6c0-0.7,0.5-1.2,1.1-1.4c0.6-0.1,1.3,0.2,1.5,0.8
                                                c0.1,0.2,0.1,0.4,0.1,0.6C14.9,18.4,14.9,19.3,14.9,20.2 M24.7,12.2c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5
                                                c0.3,0,0.5-0.2,0.5-0.5C25.3,12.4,25,12.2,24.7,12.2 M19.4,12.7c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5
                                                c0,0.3,0.2,0.5,0.5,0.5C19.2,13.2,19.4,13,19.4,12.7 M21.8,15.3h-5.6c-0.5,0-0.7-0.2-0.6-0.7c0.4-1.6,1.3-2.9,2.7-3.8
                                                c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.3c-0.3-0.5-0.6-1-0.8-1.5c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.2,0.3-0.2,0.4,0.1
                                                c0.3,0.5,0.6,1,0.9,1.5c0.1,0.2,0.2,0.2,0.3,0.1c1.6-0.7,3.3-0.7,4.9,0c0.2,0.1,0.3,0.1,0.4-0.1c0.3-0.5,0.6-1,0.8-1.5
                                                c0.1-0.1,0.2-0.2,0.4-0.2C26,8.5,26,8.7,25.9,8.8c-0.3,0.5-0.5,1-0.8,1.5c-0.1,0.2-0.1,0.2,0.1,0.4c1.5,0.9,2.5,2.3,2.9,4
                                                c0.1,0.5-0.1,0.7-0.5,0.7C25.6,15.3,23.7,15.3,21.8,15.3z M22.8,26.8h-2v0.3c0,1,0,2,0,3c0,0.6-0.4,1.2-1,1.3
                                                c-0.6,0.2-1.3-0.1-1.6-0.7c-0.1-0.2-0.2-0.5-0.2-0.8c0-1,0-1.9,0-2.9v-0.3h-0.3c-0.6,0-1.2,0-1.7,0c-0.4,0-0.5-0.2-0.5-0.5
                                                c0,0,0-0.1,0-0.1c0-3.1,0-6.3,0-9.4c0-0.6,0.1-0.7,0.7-0.7h11.4c0.5,0,0.7,0.1,0.7,0.7v9.4c0,0.5-0.1,0.7-0.7,0.7
                                                c-0.6,0-1.1,0-1.7,0c-0.2,0-0.2,0.1-0.2,0.2c0,1,0,2.1,0,3.1c0,0.5-0.3,1-0.7,1.2c-0.5,0.3-1,0.2-1.4-0.1
                                                c-0.4-0.3-0.6-0.7-0.6-1.2c0-1,0-2,0-3V26.8z"/>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </flickity>
</template>

<script>
import Flickity from 'vue-flickity';
import 'flickity-imagesloaded';

export default {
    components: {
        Flickity
    },
    data() {
        return {
            flickityOptions: {
                imagesLoaded: true,
                prevNextButtons: false,
                groupCells: true,
                contain: true,
            },
            influencers: [
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-1.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-2.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-3.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-4.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-1.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-2.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-3.jpg'
                },
                {
                    name: 'Prince Royce',
                    place: 'La Voz kids, Pequenos Gigantes USA',
                    imagePath: '/assets/images/orsus_launch-4.jpg'
                }
            ]
        }
    }
}
</script>